module.exports = __webpack_public_path__ + "static/media/nlauncher-logo-144dpi-476w.91687801.png";